import { useEffect, useState } from "react";
import axios from "axios";

const useNewsData = () => {
  const [newsData, setNewsData] = useState([]);

  const news_api_key = process.env.REACT_APP_NEWS_API;
  console.log("news_api_key", news_api_key);

  useEffect(() => {
    // fetch("https://jsonplaceholder.typicode.com/users")
    //   .then((res) => res.json())
    //   .then((data) => console.log(data));

    // .get("https://jsonplaceholder.typicode.com/users")

    axios
      .get(
        `https://newsapi.org/v2/top-headlines?country=us&category=business&apiKey=${news_api_key}`
      )
      .then((data) => setNewsData(data.data.articles));
    //   .catch((err) => console.log("UserInfo Error:", err));
  }, []);
  console.log("News Data", newsData);

  return [newsData, setNewsData];
};

export default useNewsData;
